package top.wcpe.allincore.ui.runtime.render.layer

import top.wcpe.allincore.ui.runtime.render.Renderer
import top.wcpe.allincore.ui.runtime.render.model.RenderLayer
import kotlin.jvm.JvmName

/**
 * 层-渲染器对：声明某个 [Renderer] 绘制到哪个 [RenderLayer]。
 *
 * 访问器经 [JvmName] 保留 `layer()` / `renderer()` 的 Java 方法 ABI，
 * 与 [LayerRenderers] 等 Java 调用方现有的 record 风格调用一致。
 */
data class LayerRenderer(@get:JvmName("layer") val layer: RenderLayer, @get:JvmName("renderer") val renderer: Renderer)
